import Toast from './Toast';
import raiseToastFunction from './raiseToast';

export const raiseToast = raiseToastFunction;

export default Toast;
